import React from "react";

export interface TextWithLinkProps {
  text?: string;
  link?: { link: string; text: string };
  inline?: boolean;
}

export default function textWithLink(props: TextWithLinkProps) {
  return (
    <div>
      {props.inline ? (
        <>
          <div>
            <span>{props.text}</span>
            <a
              href={props.link?.link}
              target="_blank"
              rel="noreferrer"
              onClick={e => {
                e.preventDefault();
                window.open(props.link?.link);
              }}>
              <strong>{props.link?.text}</strong>
            </a>
          </div>
        </>
      ) : (
        <>
          <div>
            <span>{props.text}</span>
          </div>
          <div>
            <a
              href={props.link?.link}
              target="_blank"
              rel="noreferrer"
              onClick={e => {
                e.preventDefault();
                window.open(props.link?.link);
              }}>
              <strong>{props.link?.text}</strong>
            </a>
          </div>
        </>
      )}
    </div>
  );
}
